import script from "./SectionHero.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionHero.vue?vue&type=script&setup=true&lang=js"

import "./SectionHero.vue?vue&type=style&index=0&id=8e4fa104&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e4fa104"]])

export default __exports__